import { createClientRequestId } from "@/lib/idempotency";

export const PORTAL_SUMMARY_EVENT = "prvbuy:portal-summary-changed";
export const PORTAL_SUMMARY_STORAGE_KEY = "prvbuy:portal-summary-version";

export function notifyPortalSummaryChanged() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(PORTAL_SUMMARY_EVENT));
  try {
    window.localStorage.setItem(PORTAL_SUMMARY_STORAGE_KEY, `${Date.now()}:${createClientRequestId()}`);
  } catch {
    // Same-tab refresh still runs when storage is unavailable.
  }
}
